import db from "@/database";

export const findDefaultByTypeId = async (typeId) => {
  const sequences = await db.sequence.where({ typeId }).toArray();
  return sequences.find((s) => s.isDefault) || sequences[0];
};

export const findByTypeId = async (typeId) => {
  return await db.sequence.where({ typeId }).toArray();
};

export const findOne = (sequenceId) => db.sequence.get(sequenceId);
